import { t } from '@lingui/macro'
import React from 'react'

/**
 * StatusBadge component for displaying candidate status with appropriate styling
 * Used in both CandidatesPage and CandidateDetailsPage for consistent status display
 */
// Status badge component for better visual representation
export const StatusBadge = ({ status }: { status: string }) => {
    let bgColor = 'bg-gray-200'
    let textColor = 'text-gray-700'
    let icon: React.ReactNode | null = null
    let displayText = status

    switch (status) {
        case 'candidate':
            bgColor = 'bg-yellow-100'
            textColor = 'text-yellow-800'
            displayText = t`Candidate`
            break
        case 'in_contact':
            bgColor = 'bg-blue-100'
            textColor = 'text-blue-800'
            displayText = t`In Contact`
            break
        case 'registered':
            bgColor = 'bg-purple-100'
            textColor = 'text-purple-800'
            displayText = t`Registered`
            break
        case 'allocated':
            bgColor = 'bg-emerald-100'
            textColor = 'text-emerald-800'
            displayText = t`Allocated`
            break
        case 'allocated_group_2':
            bgColor = 'bg-emerald-100'
            textColor = 'text-emerald-800'
            displayText = t`Allocated Group 2`
            break
        case 'allocated_group_3':
            bgColor = 'bg-violet-100'
            textColor = 'text-violet-800'
            displayText = t`Allocated Group 3`
            break
        case 'record_retrieval':
            bgColor = 'bg-indigo-100'
            textColor = 'text-indigo-800'
            displayText = t`Record Retrieval`
            break
        case 'screen_failure':
            bgColor = 'bg-rose-100'
            textColor = 'text-rose-800'
            displayText = t`Screen Failure`
            break
        case 'undecided':
            bgColor = 'bg-amber-100'
            textColor = 'text-amber-800'
            displayText = t`Undecided`
            break
        case 'declined':
            bgColor = 'bg-red-100'
            textColor = 'text-red-800'
            displayText = t`Declined`
            break
        case 'unreachable':
            bgColor = 'bg-gray-100'
            textColor = 'text-gray-800'
            displayText = t`Unreachable`
            break
        case 'duplicate':
            bgColor = 'bg-orange-100'
            textColor = 'text-orange-800'
            displayText = t`Duplicate`
            break
        default:
            // Handle legacy statuses for backward compatibility
            if (status === 'accepted') {
                bgColor = 'bg-emerald-100'
                textColor = 'text-emerald-800'
                displayText = t`Allocated Group 2`
            } else if (status === 'rejected') {
                bgColor = 'bg-red-100'
                textColor = 'text-red-800'
                displayText = t`Declined`
            } else if (status === 'pending') {
                bgColor = 'bg-yellow-100'
                textColor = 'text-yellow-800'
                displayText = t`Candidate`
            }
            break
    }

    return (
        <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full ${bgColor} ${textColor} text-sm font-medium`}>
            {icon}
            <span className='capitalize'>{displayText}</span>
        </div>
    )
}
